module.exports = __webpack_public_path__ + "img/202109171200044002ih.c5b6ab30.png";